import {Controller} from '@stimulus/core'
import HSStickyBlock from '../../../../../vendor/front/vendor/hs-sticky-block/src/js/hs-sticky-block'

// data-controller='hs--sticky-block'
// data-hs-sticky-block-options='{}' https://htmlstream.com/front/documentation/sticky-block.html

export default class extends Controller {
  connect() {
    new HSStickyBlock($(this.element)).init()
  }
}
